module.exports = __webpack_public_path__ + "img/75567.d831f27c.svg";